import { usersAdminStore } from '../admin/modules/UsersAdmin';
import { toJS } from 'mobx';

export function validateField(func: any, data: any) {
    const funcName = func.functionName;
    switch (funcName) {
        case('regexTest'):
        {
            return regexTest(func.regexParam, data)
        }
        case('emailUnique'):
        {
            return emailUnique(func.auth_id, data)
        }
        case('arrayNotEmpty'):
        {
            return arrayNotEmpty(data)
        }
        case('siteSelect'):
        {
            return siteSelect(func.active, data)
        }
        default:
        {
            return true
        }
    }
}

export function regexTest(regexParam: any, data: any) {
    if (regexParam.test(data)) {
        return true
    }
    return false
}

export function emailUnique(auth_id: number, email: any) {
    const emailCheck = usersAdminStore.allUserEmails.filter((user: any) => user.Email === email)
    // console.log(toJS( usersAdminStore.allUserEmails))
    // console.log(toJS(emailCheck))
    if (emailCheck.length > 0) {
      if (emailCheck[0].auth_id !== auth_id) {
        return false
      }
    }
    return true
}

export function arrayNotEmpty(arr: any) {
    if (arr.length === 0) {
        return false
    }
    return true
}

export function siteSelect(active: boolean, data: any) {
    if (!active) {
        return true
    }
    else {
        if (data.length > 0) {
            return true
        }
    }
    return false
}


// WEBPACK FOOTER //
// ./src/modules/validations/validatorFunctions.ts